exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".UuUgl{margin-bottom:5px;display:block;color:red;font-size:14px;font-weight:400}._2NSX9{max-width:912px;width:100%;display:block;margin:0 auto}.sVcQH{font-size:24px;color:#484848;font-weight:700}._1vM9-{font-size:20px;color:#484848}._1TK5W{height:80px!important;padding:20px;border-color:#dce0e0;border-radius:2px;font-size:14px;background-color:#fff;color:#767676}._2gvx2{font-size:18px;color:#484848;line-height:1.43}._1AyjP{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.xJO8Y{text-decoration:line-through}._2uOqM{padding:0}a,a:active,a:focus,a:hover{color:#008489;text-decoration:none}._11eya{font-weight:700}._1HvvU{border-color:#007d73;background-color:#00a699;color:#fff;font-size:16px;margin-top:15px;display:block;text-align:center}._1HvvU:hover{background:#ff5a5f}._1HvvU:focus{border-color:#ff5a5f;box-shadow:0 0 8px #00a699}._1FKKs{border-color:#ff5a5f;background-color:#ff5a5f;color:#fff}._2osOf{padding:9px 27px}.jadNq{padding:20px 36px;line-height:1;font-size:18px;text-align:center}._1FKKs:active,._1FKKs:active:focus,._1FKKs:active:hover,._1FKKs:focus,._1FKKs:hover{border-color:#ff5a5f!important;background-color:#ff5a5f!important;color:#fff}._2O3JC{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff;border:1px solid;border-radius:4px}._2O3JC:active,._2O3JC:active:focus,._2O3JC:active:hover,._2O3JC:focus,._2O3JC:hover{border-color:#ff5a5f;color:#ff5a5f;background-color:#fff}._1XOz6{padding:5px 0}.KzM_X{margin-bottom:6px}._2E3px{font-size:16px;color:#767676;line-height:1.43;font-weight:400}.vxv7Z{position:relative;z-index:1;display:block;margin:15px 1px;width:100%;color:#767676;text-align:center;font-size:14px}.gNtrq{margin-bottom:6px}.yyGyV{margin-bottom:12px}._1Ex3-{margin-bottom:18px}._2qDzh{margin-bottom:24px}._2ReQW{margin-bottom:30px}._1JQqP{margin-top:6px}._1f_cg{margin-top:12px}._9tN-G{margin-top:18px}._14zoU{margin-top:24px}.Lnjyu{margin-top:30px}._3A1-W{margin-top:36px}.IqH-N{width:100%;display:block;color:#484848;font-size:14px;padding-bottom:12px;border-bottom:1px solid #dce0e0;border-radius:0}._3Dg5T{margin:0 auto}._1v1dx,._3Dg5T{position:relative}._1v1dx{-webkit-backface-visibility:hidden;backface-visibility:hidden;display:inline-block;overflow:hidden;background-color:#bbb;border-radius:50%;border:2px solid #fff}._3H3VK{text-align:right}.KcDCZ{text-align:left}.Oxnw3{float:right}._3pXeT{float:left}._1srhg{color:#ff5a5f}@media screen and (max-width:640px){._3pXeT,.Oxnw3{float:none}._3wOMN{width:100%}}", ""]);

// exports
exports.locals = {
	"errorMessage": "UuUgl",
	"landingContainer": "_2NSX9",
	"landingContentTitle": "sVcQH",
	"landingSubTitle": "_1vM9-",
	"textareaInput": "_1TK5W",
	"textHigh": "_2gvx2",
	"textTruncate": "_1AyjP",
	"textLine": "xJO8Y",
	"noPadding": "_2uOqM",
	"textBold": "_11eya",
	"button": "_1HvvU",
	"btnPrimary": "_1FKKs",
	"btnlarge": "_2osOf",
	"btnJumbo": "jadNq",
	"btnPrimaryBorder": "_2O3JC",
	"btnSmall": "_1XOz6",
	"formGroup": "KzM_X",
	"landingStep": "_2E3px",
	"horizontalLineThrough": "vxv7Z",
	"space1": "gNtrq",
	"space2": "yyGyV",
	"space3": "_1Ex3-",
	"space4": "_2qDzh",
	"space5": "_2ReQW",
	"spaceTop1": "_1JQqP",
	"spaceTop2": "_1f_cg",
	"spaceTop3": "_9tN-G",
	"spaceTop4": "_14zoU",
	"spaceTop5": "Lnjyu",
	"spaceTop6": "_3A1-W",
	"panelHeader": "IqH-N",
	"profileAvatarSection": "_3Dg5T",
	"profileAvatarLink": "_1v1dx",
	"textRight": "_3H3VK",
	"textLeft": "KcDCZ",
	"pullRight": "Oxnw3",
	"pullLeft": "_3pXeT",
	"amountColor": "_1srhg",
	"btnWidth": "_3wOMN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Cancellation/Cancellation.css
// module id = 2523
// module chunks = 15